<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="left-box">
				<div class="left-content">
					<div class="bg-box" style="width: 100%;height: 200px;" 
					:style="'background: url('+tempBg+');'"></div>
					<div style="margin-top: -35px;box-sizing: border-box;padding: 0 12px;">
						<div class="d-flex a-center" style="height: 70px;background: #FFFFFF;border-radius: 10px;">
							<div v-for="(item,index) in use_module" style="width: 25%;text-align: center;display: inline-block;">
								<div style="width: 33px;height: 33px;cursor: pointer;border-radius: 50%;display: inline-block;" :style="'background:'+color">
									<img style="width: 33px;height: 33px;" :src="item.photo_url" />
								</div>
								
								<div style="font-size: 11px;color: #888888;">{{item.title}}</div>
							</div>
						</div>
					</div>
					
					<div style="width: 100%;background: #FFFFFF;margin-top: 12px;border-radius: 10px 10px 0 0;">
						<div v-if="curIndex==1" style="height: 51px;display: flex;align-items: center;font-weight: 700;">
							<div class="w-50 text-center">企业介绍</div>
							<div style="width: 1px;height: 12px;background: #BBBBBB;border-radius: 1px;"></div>
							<div class="w-50 text-center" style="color: #888888;">企业资料</div>
						</div>
						<div v-else-if="curIndex==2" style="height: 51px;display: flex;align-items: center;font-weight: 700;">
							<div class="w-100 text-center">产品服务</div>
						</div>
						<div v-else-if="curIndex==3" style="height: 51px;display: flex;align-items: center;font-weight: 700;">
							<div class="w-50 text-center">企业动态</div>
							<div style="width: 1px;height: 12px;background: #BBBBBB;border-radius: 1px;"></div>
							<div class="w-50 text-center" style="color: #888888;">企业发布</div>
						</div>
						<div v-else-if="curIndex==4" style="height: 51px;display: flex;align-items: center;font-weight: 700;">
							<div class="w-50 text-center" style="color: #888888;">企业动态</div>
							<div style="width: 1px;height: 12px;background: #BBBBBB;border-radius: 1px;"></div>
							<div class="w-50 text-center">企业发布</div>
						</div>
						<div v-else style="height: 51px;display: flex;align-items: center;font-weight: 700;">
							<div class="w-100 text-center">联系我们</div>
						</div>
						<div class="img-boxs" style="box-sizing: border-box;padding: 0 12px;height: 470px;overflow-y: scroll;">
							<template v-if="curIndex==1">
								<div v-if="is_template==1">
									<div>
										<div style="width: 100%;height: 455px;position: relative;">
											<img  style="height: 455px;width: 342px!important;cursor: pointer;" :src="modelData.photo_url1" />
											<div style="position: absolute;left: 0;right: 0;bottom: 99px;">
												<div class="eipt" style="background: none;font-weight: 700;color: #FFFFFF;padding: 0 12px;box-sizing: border-box;">
													{{modelData.title1}}
												</div>
											</div>
											<div style="position: absolute;left: 0;right: 0;bottom: 19px;">
												<div class="eipt" style="color: #FFFFFF!important;padding: 0 12px;box-sizing: border-box;">
													{{modelData.brief1}}
												</div>
											</div>
										</div>
										<div>
											<div class="eipt1" style="font-weight: 700;margin-top: 7px;font-weight: 700;">{{modelData.title2}}</div>
										</div>
										<div>
											<div class="eipt1" style="background: none;color: #888888;margin-top: 5px;" >
											{{modelData.brief2}}
											</div>
										</div>
										<div>
											<img @click="productStase = true" style="width: 342px;height: 100%;margin-top: 7px;cursor: pointer;" :src="modelData.photo_url2" />
										</div>
										<div>
											<div class="eipt1"
											style="font-weight: 700;margin-top: 7px;" >{{modelData.title3}}</div>
										</div>
										<div>
											<div class="eipt1" style="color: #888888;margin-top: 5px;">{{modelData.brief3}}</div>
										</div>
										<div>
											<img @click="ysStase = true" style="width: 342px;height: 100%;margin-top: 7px;cursor: pointer;" :src="modelData.photo_url3" />
										</div>
										<div>
											<div class="eipt1" style="font-weight: 700;margin-top: 7px;font-weight: 700;">
											{{modelData.title4}}
											</div>
										</div>
										<div>
											<div class="eipt1" style="color: #888888;margin-top: 5px;">
											{{modelData.brief4}}
											</div>
										</div>
									</div>
								</div>
								<div v-else-if="contenList.length==0&&jsconten==''" class="d-flex a-center j-center"
								style="width: 100%;height: 496px;background: #bbb;border-radius: 10px 10px 0px 0px;">
									<div style="text-align: center;">
										<img style="width: 62px;height: 42px;" src="../../assets/Home/moren@2x.png" >
										<div style="color: #d3d3d3;margin-top: 10px;text-align: center;">
											暂未添加内容
										</div>
									</div>
								</div>
								<div v-if="contenList.length==0" class="home-img-box"
								style="display: flex;flex-wrap: wrap;width: 100%;overflow-x: hidden;" v-html="jsconten"></div>
								<div v-if="contenList.length!=0&&is_template==0" v-for="(item,index) in contenList">
									<div  v-if="item.type==1">
										{{item.content}}
									</div>
									<div v-else>
										<img style="width: 100%;" :src="item.content" />
									</div>
								</div>
							</template>
							<template v-else-if="curIndex==2">
								<div  class="d-flex j-sb" style="flex-wrap: wrap;">
									<div v-for="(item,index) in busGoods" :key="index" 
									style="width: 170px;background: #FFFFFF;margin-top: 12px;">
										<img style="width: 170px;height: 170px;border-radius: 6px 6px 0 0;" :src="item.goods_img" />
										<div style="font-size: 14px;box-sizing: border-box;padding: 0 6px;overflow:hidden;
										text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2;">
											{{item.goods_name}}
										</div>
										<div style="height: 6px;"></div>
									</div>
								</div>
								<div style="height: 12px;"></div>
							</template>
							<template v-else-if="curIndex==3">
								<div  style="display: flex;flex-wrap: wrap; justify-content: space-between;">
									<div v-for="(item,index) in wzList" :key="index" 
									style="width: 170px; background: #FFFFFF;margin-top: 12px;">
										<img v-if="item.type==1" style="width: 170px;height: 170px;border-radius: 6px 6px 0 0;" :src="item.cover" />
										<video v-if="item.type==2" width="170" style="border-radius: 6px 6px 0 0;" :src="item.cover"/>
										<div style="font-size: 14px;box-sizing: border-box;padding: 0 6px;overflow:hidden;
										text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2;">
											{{item.title}}
										</div>
										<div class="d-flex a-center" style="padding: 0 6px;margin-top: 6px;">
											<div style="width: 30px;height: 16px;border: 1px solid #BBBBBB;border-radius: 2px;
											font-size: 10px;color: #BBBBBB;display: flex;align-items: center;justify-content: center;">
												{{item.type==1?'文章':'视频'}} 
											</div>
											<div class="text-hide" style="font-size: 10px;color: #BBBBBB;margin-left: 6px;">{{user_info.company_name}}</div>
										</div>
										<div style="height: 6px;"></div>
									</div>
								</div>
								<div style="height: 12px;"></div>
							</template>
							<template v-else-if="curIndex==4">
								<div class="j-sb" style="display: flex;flex-wrap: wrap;">
									<div v-for="(item,index) in partnerse_list" :key="index"
									style="width: 170px;height: 100px;background: #FFFFFF;border-radius: 4px;margin-top: 12px;
									display: flex;justify-content: space-between;text-align: center;flex-direction: column;box-sizing: border-box;
									padding: 15px 0;">
										<div style="text-align: center;" >
											<img style="width: 50px;height: 50px;" :src="item.logo_thumb" />
										</div>
										<div style="font-size: 14px;">{{item.company_name}}</div>
									</div>
								</div>
							</template>
							<template v-else-if="curIndex==5">
								<div style="width: 100%;height: 75px;background: #FFFFFF;box-shadow: 0px 6px 8px 0px rgba(185, 204, 255, 0.1);
								border-radius: 4px;margin-top: 12px;display: flex;align-items: center;box-sizing: border-box;padding: 0 17px;">
									<div style="width: 20px;height: 20px;border-radius: 50%;background: #1E69FF;">
									</div>
									<div style="font-size: 13px;font-weight: 700;margin-left: 10px;">客服电话</div>
									<div style="margin-left: auto;font-size: 14px;">{{user_info.kf_tel}}</div>
								</div>
								<div style="width: 100%;height: 75px;background: #FFFFFF;box-shadow: 0px 6px 8px 0px rgba(185, 204, 255, 0.1);
								border-radius: 4px;margin-top: 12px;display: flex;align-items: center;box-sizing: border-box;padding: 0 17px;">
									<div style="width: 20px;height: 20px;border-radius: 50%;background: #1E69FF;">
									</div>
									<div style="margin-left: auto;font-size: 13px;font-weight: 700;margin-left: 10px;">总部地址</div>
									<div style="font-size: 14px;flex: 1;text-align: right;">{{user_info.shop_address||'暂无地址信息'}}</div>
								</div>
								<div style="width: 100%;height: 75px;background: #FFFFFF;box-shadow: 0px 6px 8px 0px rgba(185, 204, 255, 0.1);
								border-radius: 4px;margin-top: 12px;display: flex;align-items: center;box-sizing: border-box;padding: 0 17px;">
									<div style="width: 20px;height: 20px;border-radius: 50%;background: #1E69FF;">
									</div>
									<div style="font-size: 13px;font-weight: 700;margin-left: 10px;">在线留言</div>
									<div style="margin-left: auto;font-size: 14px;">写留言</div>
									<img style="width: 13px;height: 13px;margin-left: 6px;" src="../../assets/order/jiantoujindian@2x.png" />
								</div>
							</template>
						</div>
					</div>
					<div class="tabbar-box d-flex j-sb a-center">
						<div @click="curIndex=1" style="width: 37px;height: 37px;border-radius: 50%;box-sizing: border-box;cursor: pointer;">
							<img style="width: 100%;height: 100%;border-radius: 50%;" :src="user_info.logo_thumb" />
						</div>
						<div  style="cursor: pointer;">
							<div style="text-align: center;height: 18px;">
								<img v-if="curIndex!=2" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/tabbar/qycpmr.png" />
								<img v-else style="width: 18px;height: 18px;" src="../../assets/Home/cpmr@2x.png" />
							</div>
							<div style="font-size: 11px;text-align: center;"
							:style="curIndex!=2?'color: #888888':'color: #1E69FF'">企业产品</div>
						</div>
						<div  style="cursor: pointer;">
							<div style="text-align: center;height: 18px;">
								<img v-if="curIndex!=3" style="width: 18px;height: 18px;" src="../../assets/Home/mrdt.png" />
								<img v-else style="width: 18px;height: 18px;" src="../../assets/Home/mrdt@2x.png" />
							</div>
							<div style="font-size: 11px;text-align: center;"
							:style="curIndex!=3?'color: #888888':'color: #1E69FF'">企业动态</div>
						</div>
						<div  style="cursor: pointer;">
							<div style="text-align: center;height: 18px;">
								<img v-if="curIndex!=4" style="width: 18px;height: 18px;" src="../../assets/Home/mrhb@2x.png" />
								<img v-else style="width: 18px;height: 18px;" src="../../assets/Home/mrhbls.png" />
							</div>
							<div style="font-size: 11px;text-align: center;"
							:style="curIndex!=4?'color: #888888':'color: #1E69FF'">合作伙伴</div>
						</div>
						<div  style="cursor: pointer;">
							<div style="text-align: center;height: 18px;">
								<img v-if="curIndex!=5" style="width: 18px;height: 18px;" src="../../assets/brand_fixtures/tabbar/qyhzmr.png" />
								<img v-else style="width: 18px;height: 18px;" src="../../assets/Home/mrlx@2x.png" />
							</div>
							<div style="font-size: 11px;text-align: center;"
							:style="curIndex!=5?'color: #888888':'color: #1E69FF'">联系我们</div>
						</div>
						
					</div>
				</div>
				<div class="d-flex" style="margin-top: 27px;box-sizing: border-box;padding: 0 30px;align-items: center;">
					<div @click="setMdindex(0)" class="d-flex j-center a-center" :style="mdindex==0?'background: #1E69FF;':'background: #cccccc;'"
					style="width: 114px;height: 26px;border-radius: 6px;font-size: 12px;color: #FFFFFF;cursor: pointer;">
						公司首页模块
					</div>
					<div @click="setMdindex(1)" class="d-flex j-center a-center" :style="mdindex==1?'background: #1E69FF;':'background: #cccccc;'"
					style="width: 114px;height: 26px;border-radius: 6px;font-size: 12px;color: #FFFFFF;cursor: pointer;margin-left: auto;">
						产品/服务模块
					</div>
					<!-- <img @click="setMdindex(0)" style="width: 15px;height: 15px;transform: rotate(180deg);cursor: pointer;" src="../../assets/order/jiantoujindian@2x.png" />
					<div style="flex: 1;text-align: center;" v-if="mdindex==0"></div>
					<div style="flex: 1;text-align: center;" v-else></div>
					<img @click="setMdindex(1)" style="width: 15px;height: 15px;margin-left: auto;cursor: pointer;" src="../../assets/order/jiantoujindian@2x.png" /> -->
				</div>
			</div>
			<div class="right-box">
				<div class="message-list-box">
					<div class="message-list">
						<div style="font-size: 12px;height: 50px;display: flex;align-items: center;">
							可根据企业需求设定相应的功能模块
							<span style="color: #888888;">点击模块可编辑内容</span>
							<div class="d-flex a-center" style="font-size: 14px;height: 52px;color: #000;font-weight: 700;margin-left: auto;position: relative;">
								编辑图标颜色：
								<!-- <div style="height: 32px;width: 558px;margin-left: auto;border: 6px;" :style="'background:'+color">
								</div> -->
								<el-color-picker @change="changeColor()" v-model="color" size="small" style="margin-left: auto;opacity: 0;z-index: 2;"></el-color-picker>
								<img style="width: 20px;height: 20px;position: absolute;right: 5px;z-index: 1;" src="../../assets/Home/xzys.png" />
							</div>
						</div>
						
						<el-checkbox-group style="display: flex;flex-wrap: wrap;margin-top: 0px;" v-model="checkList">
							<div style="width: 50%;" class="d-flex j-center" v-for="(item,index) in moduleList">
								<div style="width: 200px;height: 50px;border-radius: 6px;position: relative;" class="d-flex a-center">
									<!-- <div style="position: absolute;top: 12px;right: 12px;">
										<el-checkbox  :label="item.module_id" ><br /></el-checkbox>
									</div> -->
									<label style="display: flex;align-items: center;">
										<div>
											<el-checkbox  :label="item.module_id" ><br /></el-checkbox>
										</div>
										<div>
											<!-- <div style="width: 63px;height: 63px;cursor: pointer;border-radius: 50%" :style="'background:'+color">
												<img @click="constitution(item)" style="width: 63px;height: 63px;cursor: pointer;" :src="item.photo_url" />
											</div> -->
											<div  style="color: #888888;font-size: 15px;cursor: pointer;">{{item.title}}</div>
										</div>
									</label>
									
									<img @click="constitution(item)" style="width: 14px;height: 14px;margin-left: auto;cursor: pointer;" src="../../assets/Home/jiantou.png" />
								</div>
							</div>
						 </el-checkbox-group>
						 
					</div>
					<div @click="get_fcib_module_set" class="d-flex j-center" style="margin-top: 60px;">
						 <div class="d-flex j-center a-center"
						 style="width: 114px;height: 26px;background: #1E69FF;border-radius: 6px;
						 font-size: 12px;color: #FFFFFF;cursor: pointer;">
							 设为开放功能
						 </div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  title=" "
		  :visible.sync="showjs"
		  width="1170px"
		  center>
		  <div class="d-flex j-center">
			  <img style="width: 827px;height: 733px;" src="../../assets/Home/neirong@2x.png" />
		  </div>
		</el-dialog>
	</div>

</template>

<script>
	
	export default {

		data() {
			return{
				userinfo:'',
				wzList:[],
				currentPage: 1, //初始页
				pageSize : 10,
				megData: [],
				total_records : 0,
				tempBg:'',
				user_info:'',
				jsconten:'',
				contenList:[],
				curIndex:1,
				busGoods:[],
				wzList:[],
				partnerse_list:[],
				modelData:'',
				is_template:0,
				showjs:false,
				checkList: [],
				moduleList:[],
				use_module:[],
				color:'#D32526',
				mdindex:0
			}
		},
		methods:{
			setMdindex(index){
				this.mdindex = index
				this.get_fcib_all_module()
				this.get_fcib_use_module()
			},
			constitution(item){
				this.$router.push('constitution?state='+item.module_id)
				return
				// console.log(item);
				// return
				if(item.module_id == 142){
					this.$router.push('constitution?state=get_fcib_rules')
				}
				if(item.module_id == 143){
					this.$router.push('constitution?state=get_fcib_osc')
				}
				if(item.module_id == 144){
					this.$router.push('constitution?state=get_fcib_pb')
				}
				if(item.module_id == 145){
					this.$router.push('constitution?state=get_fcib_st')
				}
				if(item.module_id == 146){
					this.$router.push('constitution?state=get_fcib_sdi')
				}
				if(item.module_id == 147){
					this.$router.push('constitution?state=get_fcib_ar')
				}
				if(item.module_id == 148){
					this.$router.push('constitution?state=get_fcib_hcc')
				}
				
			},
			changeColor(){
				if(this.color){
					let params = {
						act:'enterprise_color_code_set',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						color_code:this.color
					}
					this.$api.get_fcib_module_set(params).then((res)=>{
						if(res.code == 0){
							this.get_enterprise_color_code()
						}
					})
					
				}
			},
			//获取已设定模块
			get_fcib_use_module(){
				this.use_module = []
				let params = {
					act:'enterprise_get_user_role',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:this.mdindex
				}
				this.$api.get_fcib_use_module(params).then((res)=>{
					if(res.code == 0){
						this.use_module = res.data
					}
				})
			},
			//设置模块
			get_fcib_module_set(){
				if(this.checkList.length == 0){
					return
				}
				let params = {
					act:'enterprise_role_submit',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					module_ids:this.checkList.join(','),
					type:this.mdindex
				}
				this.$api.get_fcib_module_set(params).then((res)=>{
					if(res.code == 0){
						this.checkList = []
						this.$message({
							showClose: false,
							message: '操作成功',
							type: 'success',
							offset: 350
						})
						this.get_fcib_all_module()
						this.get_fcib_use_module()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			//获取所有模块列表
			get_fcib_all_module(){
				
				let params = {
					act:this.mdindex == 0 ? 'enterprise_get_index_role' : 'enterprise_get_goods_role',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type:this.mdindex
				}
				this.$api.get_fcib_all_module(params).then((res)=>{
					this.moduleList = res.data
					this.checkList = []
					res.data.forEach((item)=>{
						if(item.is_use == 1){
							this.checkList.push(item.module_id)
						}
					})
					// this.color = res.fcib_color_code
				})
			},
			get_enterprise_color_code(){
				let params = {
					act:'get_enterprise_color_code',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.get_fcib_all_module(params).then((res)=>{
					this.color = res.data.enterprise_color_code
				})
			},
			//获取企业介绍
			business_intro(){
				let params = {
					act:'business_intro',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id'),
				}
				this.$api.business_intro(params).then((res)=>{
					if(res.code == 0){
						if(typeof res.data.business_intro == 'object' || localStorage.getItem('store_type') == 0){
							let bus = res.data.business_intro
							if(localStorage.getItem('store_type') == 0){
								bus = JSON.parse(res.data.business_intro)
							}
							this.contenList = bus
							this.modelData = res.data.business_intro
							this.is_template = res.data.is_template
						}else{
							this.jsconten = res.data.business_intro
						}
					}
				})
			},
			//获取企业介绍背景图
			get_enterprise_introduction_backdrop(){
				
				let params = {
					act:'get_enterprise_introduction_backdrop',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				
				this.$api.get_enterprise_introduction_backdrop(params).then((res)=>{
					if(res.code == 0){
						this.tempBg = res.data.img_url
					}
				})
			},
			getLiveFiles(file, fileList) {
			    this.getBase64(file.raw).then((res) => {
					
					let params = {
						act:'upload_store_logo',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						file: res
					}
					
					this.$api.upload_store_logo(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								showClose: false,
								message: '更换成功',
								type: 'success',
								offset: 350
							})
							this.get_company_info()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350
							})
						}
					})
			    })
			},
			getBase64(file) {
			  return new Promise(function(resolve, reject) {
				const reader = new FileReader()
				let imgResult = ''
				reader.readAsDataURL(file)
				reader.onload = function() {
				  imgResult = reader.result
				}
				reader.onerror = function(error) {
				  reject(error)
				}
				reader.onloadend = function() {
				  resolve(imgResult)
				}
			  })
			},
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					localStorage.setItem('user_info', JSON.stringify(res.data))
					this.user_info = res.data
				})
			},
			//获取文章列表
			get_enterprise_dynamic_list(){
				let params = {
					act:'business_dynamic',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:2,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.get_enterprise_dynamic_list(params).then((res)=>{
					this.wzList  = []
					if(res.code == 0){
						this.wzList = res.data
					}
				})
			},
			handleSizeChange(size) {
				this.pageSize = size;
				this.leave_message_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.leave_message_list()
			},
			//获取留言列表
			leave_message_list(){
				
				let params = {
					act:'leave_message_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage
				}
				this.$api.leave_message_list(params).then((res)=>{
					this.megData  = []
					if(res.code == 0){
						this.megData = res.data
						this.total_records = res.total_records
					}
				})
			},
			//删除留言
			leave_message_del(item){
				let params = {
					act:'leave_message_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.leave_message_del(params).then((res)=>{
					if(res.code == 0){
						
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
					this.leave_message_list()
				})
			},
			//企业产品
			business_goods_list(){
				
				let aprams = {
					act:'business_goods_list',
					size:20,
					page:1,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					business_id: localStorage.getItem('ru_id')
				}
				
				this.$api.business_goods_list(aprams).then((res)=>{
					this.busGoods = res.data
				})
			},
			//获取文章列表
			get_enterprise_dynamic_list(){
				let params = {
					act:'business_dynamic',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:99,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.get_enterprise_dynamic_list(params).then((res)=>{
					this.wzList  = []
					if(res.code == 0){
						this.wzList = res.data
					}
				})
			},
			//获取合作伙伴列表
			my_partnerse_list(){
				let params = {
					act:'my_partnerse_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:20
				}
				this.$api.my_partnerse_list(params).then((res)=>{
					this.partnerse_list = res.data
				})
			}
		},
		mounted() {
			this.get_enterprise_dynamic_list()
			this.get_company_info()
			// this.leave_message_list()
			this.get_enterprise_introduction_backdrop()
			this.business_intro()
			// this.business_goods_list()
			// this.get_enterprise_dynamic_list()
			// this.my_partnerse_list()
			this.get_fcib_all_module()
			this.get_fcib_use_module()
			this.get_enterprise_color_code()
		}
	}
</script>
<style type="text/css">
	.home-img-box img{
		width: 100%!important;
	}
</style>
<style scoped>
	.eipt >>> .el-input__inner{
		color: #FFFFFF;
	}
	.eipt >>> .el-input__inner {
	    background: transparent !important;
		border-radius: 0;
		border: 1px dashed #FFFFFF;
	}
	.eipt1 >>> .el-input__inner {
		border-radius: 0;
		border: 1px dashed #888888;
	}
	.eipt >>> .el-textarea__inner{
		color: #FFFFFF;
	}
	.eipt >>> .el-textarea__inner {
	    background: transparent !important;
		border-radius: 0;
		border: 1px dashed #FFFFFF;
	}
	.eipt1 >>> .el-textarea__inner {
	    background: transparent !important;
		border-radius: 0;
		border: 1px dashed #888888;
	}
	.bg-box{
		background-size: 100% 100%!important
	}
	.content-box{
		width: 1170px;
		min-height: 960px;
		border-radius: 6px;
		display: flex;
	}
	.tabbar-box{
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px -10px 20px 0px rgba(209, 209, 209, 0.48);
		border-radius: 0 0 10px 10px;
		padding: 0 13px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.left-box{
		width: 500px;
		background: #FFFFFF;
		box-sizing: border-box;
		padding: 24px 52px;
		border-radius: 6px;

	}
	.left-content{
		box-sizing: border-box;
		width: 100%;
		height: 790px;
		border-radius: 14px;
		border: 10px solid #0C275E;
		margin-top: 35px;
		position: relative;
		background: #EFEFEF;
	}
	.left-top{
		width: 500px;
		height: 330px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 38px 0px;
		position: absolute;
	}
	.qyinfo-box{
		width: 500px;
		height: 150px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 23px 20px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	.bradn-info{
		width: 500px;
		height: 310px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 24px 20px;
	}
	.service-info{
		width: 499px;
		height: 107px;
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 20px;
		box-sizing: border-box;
		padding: 22px 20px;
	}
	.right-box{
		margin-left: 20px;
		flex: 1;
	}
	.message-admin{
		width: 100%;
		height: 60px;
		background: #FFFFFF;
		border-radius: 6px;
		box-sizing: border-box;
		padding: 0px 20px;
		display: flex;
		align-items: center;
	}
	.message-list-box{
		width: 100%;
		height: 960px;
		background: #FFFFFF;
		border-radius: 6px;
	}
	.message-list{
		height: 800px;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 0 20px;
	}
	.message-item-box{
		margin-top: 20px;
	}
	.img-boxs::-webkit-scrollbar{
		background: #f5f5f5;
		width: 5px;
	}
	.img-boxs::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #CCCCCC;
		width: 5px;
	}
	.tab-box::-webkit-scrollbar{
		background: #f5f5f5;
		height: 4px;
	}
	.text-hide{
		overflow:hidden;
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:1;
	}
</style>
